import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import {SelfAttendanceData} from "../../../shared/model/self-attendance-data";
import {environment} from "../../../../environments/environment";
import {SelfAttendanceService} from "../../../shared/services/self-attendance.service";
import {ActivatedRoute, Router} from "@angular/router";
import {SessionStorageService} from "../../../shared/services/session-storage.service";
import {DtmService} from "../../../services/dtm.service";
import {SYDLEClientID} from "../../../shared/constants/one-constants";
import {disablePackageError, enablePackageError, handleIntegrationError} from "../../../shared/constants/errors";
import {Dtm, getDtm} from "../../../shared/enum/dtm";
import {ShopWindowItem} from "../../../shared/model/shop-window-item";
import { CreditCardData } from 'src/app/shared/model/credit-card-data';
import { BreadcrumbService } from 'src/app/shared/services/breadcrumb.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogLoadingComponent } from 'src/app/shared/components/dialog-loading/dialog-loading.component';
import { LoadingComponent } from 'src/app/shared/components/loading/loading.component';

@Component({
    selector: 'pme-self-attendance-auto-recharge-disable',
    templateUrl: './auto-recharge-disable.component.html',
    styleUrls: ['./auto-recharge-disable.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class SelfAttendanceAutoRechargeDisableComponent implements OnInit {


  selfAttendanceData: SelfAttendanceData;
  submitting: boolean;

  heroData: any;
  classificationIdentifier: string;

  cancelFormErrors: Array<string> = [];
  showData: boolean = false;



  // Hero de Sucesso
  // heroData = {
  //   type: 'success',
  //   title: 'Recarga garantida desativada!',
  //   contents: ['TODO'],
  //   showButton = true,
  //   buttonName = 'Voltar para a página inicial',
  //   redirectURL = 'TODO'
  // }

  // SessionStorage Variables ( REMOVER DEFAULT )
  userId: string;
  businessId: string;
  redirectUrl: string = environment.serasaHomePage;
  showErrorHero: boolean = false;
  shopWindowLink: string;

  constructor(
    public selfAttendanceService: SelfAttendanceService,
    private route: ActivatedRoute,
    private router: Router,
    private sessionStorageService: SessionStorageService,
    public dtmService: DtmService,
    public dialog: MatDialog
  ) {
    if (!this.sessionStorageService.isReloading()) {
      localStorage.removeItem('selfAttendanceData');
      this.sessionStorageService.resetSessionStorage();
    }
    sessionStorage.setItem('shopWindowRoute', 'recharge')
    this.sessionStorageService.clearSessionStorage(
      ['category', 'product', 'identificacaoCompleted', 'pagamentoCompleted', 'sucessoCompleted']);

    this.classificationIdentifier = this.sessionStorageService.checkAndSetClassification(this.route);
    // Gets the UserID and BusinessId from SessionStorage
    this.getProvisioningParametersFromSessionStorage();
    this.dtmService.pageLoaded(Dtm.DesativarRecarga, true, getDtm(Dtm.DesativarRecarga, this.classificationIdentifier));

    this.route.queryParams.subscribe((params) => {
      if (params.userId && params.businessId) {
        this.userId = params.userId;
        this.businessId = params.businessId;
        this.setProvisioningParametersOnSessionStorage();
      }

      if (params.redirectUrl) {
        this.redirectUrl = params.redirectUrl;
      }

      this.selfAttendanceService.redirectURL = this.redirectUrl;
      sessionStorage.setItem('redirectURL', this.redirectUrl);
      sessionStorage.setItem('selfAttendance', 'true');
    });


  }

  ngOnInit() {
    this.openDialogSpinner();
    this.heroData = {
      type: 'warn',
      title: 'Desativar recarga garantida',
      contents: ['Com a <b class="pme-dark-primary-text">Recarga Garantida</b> você não precisa se preocupar em comprar créditos sempre que o crédito estiver baixo. Não deixe de consultar quando sua empresa mais precisar.']
    };


    this.selfAttendanceService.getDisableAutomaticRechargeData(this.businessId, this.userId).subscribe(
      (selfAttendanceData) => {
        this.selfAttendanceData = selfAttendanceData;
        this.selfAttendanceService.redirectURL = this.redirectUrl;
        this.selfAttendanceService.setCurrentSelfAttendanceData(selfAttendanceData);

        // Se a recarga da carteira ja esta desativada, redireciona para Ativar Recarga Garantida
        // Redireciona ja para /recarga-garantida/pagamento, com o pacote atual ou o ultimo do cliente
        // ja selecionado. Esse dado vem do ONE.
        if (selfAttendanceData.service && selfAttendanceData.service === "ACTIVATE_AUTO_RECHARGE") {
          // Redirecionar para a tela de pagamento da Recarga Garantida
          this.selfAttendanceData.selectedPackage = new ShopWindowItem(selfAttendanceData.selectedPackage);
          this.selfAttendanceService.setCurrentSelfAttendanceData(this.selfAttendanceData);
          this.router.navigate(['../recarga-garantida/pagamento'], {relativeTo: this.route});

          if (selfAttendanceData.account.wallet.automaticRecharge.paymentData.creditCard) {
            this.selfAttendanceData.creditCardData = new CreditCardData(selfAttendanceData.account.wallet.automaticRecharge.paymentData.creditCard);
          }

          return;
        }

        if (selfAttendanceData.account.wallet.automaticRecharge.paymentData.creditCard) {
          this.selfAttendanceData.creditCardData = new CreditCardData(selfAttendanceData.account.wallet.automaticRecharge.paymentData.creditCard);
        }

        sessionStorage.setItem('name', selfAttendanceData.account.name);
        sessionStorage.setItem('email', selfAttendanceData.account.email);
        this.dtmService.productsLoaded(
          [{
            'classificationName': selfAttendanceData.account.wallet.automaticRecharge.product.classificationName,
            'identifier': selfAttendanceData.account.wallet.automaticRecharge.product.identifier
          }]
          );
        },
        (error) => {
          this.dtmService.sendPageLoadEvent();
          this.showCustomError('disablePackageError', error);
          this.router.navigate(['../alterar-recarga-garantida'], {relativeTo: this.route});
        },
        () => {
          this.dtmService.sendPageLoadEvent();
        }
    )



    this.closeDialogSpinner();
    this.showData = true;

  }

  onSubmit() {
    this.submitting = true;
    this.cancelFormErrors = [];
    this.selfAttendanceService.disableAutomaticRecharge(this.userId, this.businessId).subscribe(
      (selfAttendanceData) => {
        this.selfAttendanceData = selfAttendanceData;
        this.selfAttendanceService.setCurrentSelfAttendanceData(selfAttendanceData);
        // _satellite.track("cancelamento-sucesso-SDSN"); || _satellite.track("cancelamento-sucesso-Recharge");
        this.dtmService.customClickEvent(`DesativarRecargaGarantida`);
        this.dtmService.sendPageLoadEvent('cancelamento-sucesso-Recharge');
        this.router.navigate(['../sucesso'], {relativeTo: this.route});
      }, (error) => {
        this.showCustomError('desativationError', error);
      }
    )
  }


  getProvisioningParametersFromSessionStorage() {
    this.userId = this.sessionStorageService.getUserId();
    this.businessId = this.sessionStorageService.getBusinessId();

    this.dtmService.userLoaded({
      'userId': this.userId,
      'businessId': this.businessId,
      'clientId': SYDLEClientID
    });

    if (!this.userId || !this.businessId) {
      this.sessionStorageService.setIsLogged(false);
    } else {
      this.sessionStorageService.setIsLogged(true);
    }
  }

  setProvisioningParametersOnSessionStorage() {
    this.sessionStorageService.setUserIdAndBusinessId(this.userId, this.businessId);
    this.dtmService.userLoaded({
      userId: this.userId,
      businessId: this.businessId,
      clientId: SYDLEClientID,
    });

    if (this.userId && this.businessId) {
      this.sessionStorageService.setIsLogged(true);
    }
  }


  showCustomError(customErrorKey: string, integrationError?: any) {
    let integrationErrorMessage: any;

    switch (customErrorKey) {
      case 'disablePackageError':
        integrationErrorMessage = this.showCustomHeroError(integrationError, 'disablePackageError');

        console.error(integrationErrorMessage);

        // Analytics
        this.dtmService.customErrorLoaded(["error"], {
          errorDetail: integrationErrorMessage.errorString,
          errorMessage: integrationErrorMessage.userMessage,
        });
        break;

      case 'desativationError':
        integrationErrorMessage = handleIntegrationError(integrationError);

        console.error(integrationErrorMessage);

        this.cancelFormErrors.push(integrationErrorMessage.userMessage);

        // Analytics
        this.dtmService.customErrorLoaded(["error"], {
          errorDetail: integrationErrorMessage.errorString,
          errorMessage: integrationErrorMessage.userMessage,
        });
        break;
      default:
        break;
    }
  }

  showCustomHeroError(error, type) {
    let resultError: any = {};

    try {
      if (typeof error === "string") {
        error = JSON.parse(error);
      }

      if (error.status && error.error) {
        resultError.status = error.status;
        resultError.endpoint = error.url;
        resultError.name = error.name;

        resultError.handledError = !!error.error._messages.filter((message) => {
          return message.code !== null;
        });

        resultError.errors = error.error._messages.filter((message) => {
          return message.type === "ERROR";
        });

        resultError.warnings = error.error._messages.filter((message) => {
          return message.type === "WARNING";
        });

        // Nova errorString
        resultError.errorString = (resultError.context || "SYDLE") + ":CODE:" + error.status + ":HTTP:" + (resultError.errorCode || resultError.status) + ":POST/" + resultError.endpoint + ":" + JSON.stringify(resultError.errors.map(({ text }) => text));

        /*resultError.errorString = `${resultError.status}:${resultError.name}:${resultError.endpoint}:${JSON.stringify(resultError.errors)}:${JSON.stringify(resultError.warnings)}`;*/

        resultError.userMessage = error.error._messages[0].text;
        resultError.code = error.error._messages[0].code;

        switch (type) {
          case 'disablePackageError':
            if (disablePackageError[resultError.code]) {
              this.heroData.type = 'error';
              this.heroData.title = disablePackageError[resultError.code].title;
              this.heroData.contents = disablePackageError[resultError.code].contents;
            } else {
              this.heroData.type = 'error';
              this.heroData.title = 'Serviço indisponível!';
              this.heroData.contents = ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.']
            }
            break;
          default:
            this.heroData.type = 'error';
            this.heroData.title = 'Serviço indisponível!';
            this.heroData.contents = ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.']
            break;
        }
      }
    } catch (e) {
      console.error(e);
      resultError.errorString = JSON.stringify(error);
      this.heroData.type = 'error';
      this.heroData.title = 'Serviço indisponível!';
      this.heroData.contents = ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.']
    }

    this.heroData.showButton = true;
    this.heroData.buttonName = 'Voltar';
    this.heroData.redirectURL = this.redirectUrl;
    this.showErrorHero = true;
    return resultError;
  }

  returnPage() {
    window.location.href = this.redirectUrl;
  }

  openDialogSpinner(): void {
    this.closeDialogSpinner();
    this.dialog.open(LoadingComponent, {
      disableClose: true,
      width: '400px',
      panelClass: 'pme-dialog-loading-panel',
      backdropClass: 'pme-dialog-loading-backdrop'
    });
  }

  closeDialogSpinner(): void {
    this.dialog.closeAll();
  }
}
